import { useResponsive } from '../../../hooks/useResponsive';
import ServicesDesktop from './ServicesDesktop';
import ServicesMobile from './ServicesMobile';
import { useServices } from './useServices';

const Services = () => {
  const breakpointIndex = useResponsive([1024]);
  const props = useServices();

  if (breakpointIndex === 0) {
    return <ServicesMobile {...props} />;
  }
  return <ServicesDesktop {...props} />;
};

export default Services;
